import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "../../../styles/Form.css";
import { FIELDS, MODE } from "../../../constants/SiteConstants";
import AWS from "../../../utils/awsConfig.js";
import CompanyForm from "./CompanyForm.js";

const API_URL = process.env.REACT_APP_API_URL;

const fields = [
  { label: "Title", name: "title", placeholder: "Enter Title", required: true },
  {
    label: FIELDS.SLUG,
    name: "slug",
    placeholder: "Enter Slug",
  },
  {
    label: "Brief Description",
    name: "briefDescription",
    placeholder: "Enter brief description",
    required: true,
  },
  {
    label: "Description",
    name: "description",
    placeholder: "Enter description",
    required: true,
    type: "rich-text",
  },
  {
    label: "Image",
    name: "images",
    placeholder: "Choose Image",
    type: "file",
    // required: true,
  },
];

const AddCompany = () => {
  const navigate = useNavigate();
  const [imageFiles, setImageFiles] = useState([]);
  const [imagePreview, setImagePreview] = useState([]);

  const handleImageUpload = async (files) => {
    const s3 = new AWS.S3();
    const uploadPromises = files.map((file) => {
      const params = {
        Bucket: "solar-station",
        Key: `${Date.now()}-${file.name}`,
        Body: file,
        ACL: "public-read",
      };

      return s3.upload(params).promise();
    });

    try {
      const uploadResults = await Promise.all(uploadPromises);
      return uploadResults.map((result) => result.Location);
    } catch (error) {
      toast.error("Error uploading image: " + error.message);
      throw error;
    }
  };

  const handleSubmit = async (formData) => {
    try {
      if (imageFiles.length > 0) {
        const uploadedImageUrls = await handleImageUpload(imageFiles);
        formData.images = uploadedImageUrls;
      }
      await axios.post(`${API_URL}/company/addCompany`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      toast.success("Data added successfully", { autoClose: 1000 });
      navigate("/companyManagement");
    } catch (error) {
      toast.error("Error adding data", { autoClose: 1000 });
    }
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setImageFiles(files);
    const previewUrls = files.map((file) => URL.createObjectURL(file));
    setImagePreview(previewUrls);
  };

  return (
    <div className="form-wrapper shadow-md">
      <div className="form-header">
        <h3 className="font-medium text-black border-b border-gray-300 pb-2 w-full">
          Add company
        </h3>
        <button
          className="form-close-btn"
          onClick={() => navigate("/companyManagement")}
        >
          &times;
        </button>
      </div>
      <CompanyForm
        mode={MODE.ADD}
        onSubmit={handleSubmit}
        fields={fields}
        imagePreview={imagePreview}
        handleImageChange={handleImageChange}
      />
    </div>
  );
};

export default AddCompany;
